<template>
  <div class="app-container">
    <Sidebar />
    <div class="main-content">
      <router-view style="height: 100%; width: 100%; overflow: auto" />
    </div>
  </div>
</template>

<script setup>
import "@/assets/css/index.scss";
import { ref, computed, watch, onBeforeMount, onMounted, nextTick } from "vue";
import Sidebar from "./components/Sidebar.vue";

let props = defineProps({});

onMounted(() => {
  setRipplesBj();
});

let setRipplesBj = () => {
  $(".main-content").ripples({
    resolution: 512, //分辨率
    dropRadius: 5, //半径
    perturbance: 0.01, //扰动
  });
};
</script>

<style lang="scss">
html{
  font-size: 10px;
}
.app-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  .sidebar-container {
    width: 120px;
  }
  .main-content {
    box-sizing: border-box;
    height: 100vh;
    width: calc(100vw - 120px);
    background: url(./assets/img/bj.jpg);
    background-size: cover;
    background-position: center;
    color: #fff;
  }
}

@media (max-width: 600px) {
  .sidebar-container {
    width: 70px !important;
    .top-box {
      flex-direction: column;
      img {
        margin: auto !important;
      }
    }
    .sidebar-menu {
      img {
        display: none;
      }
    }
    .bottom-box {
      flex-direction: column;
    }
  }
  .main-content {
    width: calc(100% - 70px) !important;
  }
}
</style>
